// WhyChooseUs.jsx
import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import "./introduce.css";

const features = [
  {
    icon: "🚀",
    title: "Blazing Fast Performance",
    description:
      "Next-gen Apple M5 chip and optimized software deliver lightning speed for any task.",
  },
  {
    icon: "🎨",
    title: "Stunning Visuals",
    description:
      "Nano-Texture Glass and Retina displays bring every detail to life with true-to-life colors.",
  },
  {
    icon: "🔋",
    title: "All-Day Battery",
    description:
      "Work, create, and play without worrying about charging — up to 20 hours of power.",
  },
  {
    icon: "🔒",
    title: "Privacy First",
    description:
      "Built-in security features keep your data safe, both online and offline.",
  },
  {
    icon: "🌍",
    title: "Eco-Friendly",
    description: "Made with 100% recycled aluminum and responsible materials.",
  },
  {
    icon: "💡",
    title: "Seamless Ecosystem",
    description:
      "Works perfectly with iPhone, Apple Watch, and all your Apple devices.",
  },
  
];

const Introduce = () => {
  return (
    <section className="why-choose-us">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="section-header d-block text-center mb-5"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <span className="badge">Why Choose our Product</span>
          <h2>Experience the Difference</h2>
          <p>
            From performance to sustainability, we’ve engineered every detail to
            elevate your daily life.
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -8, transition: { duration: 0.2 } }}
            >
              {/* <div className="feature-icon">{feature.icon}</div> */}
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </div>

        {/* CTA Banner */}
        <motion.div
          className="cta-banner"
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <div className="cta-text">
            <h3>Ready to upgrade your workflow?</h3>
            <p>Explore the latest lineup and find your perfect device.</p>
          </div>
          <NavLink to="/shop">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="cta-button"
            >
              Shop Collection →
            </motion.button>
          </NavLink>
        </motion.div>
      </div>
    </section>
  );
};

export default Introduce;
